import React, { memo, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { getCustomerProfile } from 'src/selectors/customer'
import { useNavigate } from 'react-router-dom'
import { FullScreenLoader } from 'src/components/shared/FullScreenLoader'
import { Button } from 'src/components/shared/Button'
import tw from 'twin.macro'
import { ChevronLeftMinor } from '@shopify/polaris-icons'
import { ROUTES } from 'src/constants/routes'
import { CustomerBankPaymentForm } from 'src/components/customer/customer-payment-method-form/BankPaymentForm'
import { CustomerUploadBankInformation } from 'src/constants/actionTypes'
import { useAsyncDispatchWithErrorToast } from 'src/hooks/useAsyncDispatchWithErrorToast'
import { BankInformationRequest } from 'src/components/customer/customer-payment-method-form/BankPaymentForm.interface'

const CustomerResubmitPaymentMethodPageComponent = () => {
  const navigate = useNavigate()
  const { asyncDispatchWithErrorToast } = useAsyncDispatchWithErrorToast()

  const customerProfile = useSelector(getCustomerProfile)

  const handleBack = useCallback(() => {
    navigate(ROUTES.BASE_URL)
  }, [navigate])

  const handleSubmitBankInformation = useCallback(
    async (requestBody: BankInformationRequest) => {
      await asyncDispatchWithErrorToast(CustomerUploadBankInformation.request(requestBody))
      navigate(ROUTES.BASE_URL)
    },
    [asyncDispatchWithErrorToast, navigate],
  )

  if (!customerProfile) {
    return <FullScreenLoader />
  }

  return (
    <>
      <CustomerBankPaymentForm
        showCurrentPaymentMethod={true}
        onSubmitBankInformation={handleSubmitBankInformation}
      />
      <div css={tw`absolute left-4 top-20`}>
        <Button
          onClick={handleBack}
          leftIcon={<ChevronLeftMinor width={20} height={20} fill="white" />}
          size="small"
          color="black"
        >
          Back
        </Button>
      </div>
    </>
  )
}

export const CustomerResubmitPaymentMethodPage = memo(CustomerResubmitPaymentMethodPageComponent)
